import { get, post } from "../../helpers/iframeHelpers";

/**
 * Returns the country guessed by the backend during
 * the email signup workflow.
 */
export const guessCountryForSignup = async () => {
  try {
    const { country } = await post("/api/guess_country");
    return country;
  } catch {
    return undefined;
  }
};

/**
 * Get the set of Dunlop Api properties
 */
export const fetchProperties = async () => {
  try {
    const { properties } = await get("/api/properties/v2?platform=WEB");
    return properties;
  } catch {
    return undefined;
  }
};
